// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { getBinaryStreamResponse } from "./getBinaryStreamResponse-web.mjs";
